import React, { useState } from 'react';

function OvertimeRequestForm({ onSubmit, loading }) {
  const [reason, setReason] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = reason.trim();
    if (!trimmed) return;
    onSubmit({ reason: trimmed });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-2">
        <label className="form-label small fw-semibold" htmlFor="overtime-reason">
          Reason for Overtime
        </label>
        <textarea
          id="overtime-reason"
          className="form-control form-control-sm"
          rows={4}
          placeholder="Enter the dates (with weekdays) and provide the reason for your request."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          required
        />
      </div>
      <button type="submit" className="btn btn-primary btn-sm" disabled={loading || !reason.trim()}>
        {loading ? 'Submitting...' : 'Submit request'}
      </button>
    </form>
  );
}

export default OvertimeRequestForm;
